export default __webpack_public_path__ + "static/media/ITRealCase3-moblie.0d891f84.jpg";